module.exports = __webpack_public_path__ + "static/img/protopie.ba551fa.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/programs_icons/protopie.svg
// module id = 6b5D
// module chunks = 1